import { render, staticRenderFns } from "./s-phone-number-field.vue?vue&type=template&id=181359ee&scoped=true"
import script from "./s-phone-number-field.vue?vue&type=script&lang=js"
export * from "./s-phone-number-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181359ee",
  null
  
)

export default component.exports